import { Box, Container, Drawer } from '@material-ui/core'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import AddButton from 'src/components/helperComponents/AddButton'
import DataTableNew from 'src/components/helperComponents/DataTable/DataTableNew'
import DialogComponent from 'src/components/helperComponents/DialogComponent'
import PlayerComponent from 'src/components/helperComponents/PlayerComponent'
import AddEditVocabulary from 'src/components/vocabulary/AddEditVocabulary'
import { DeleteVocabularyById } from 'src/redux/actions'
import { GetLessonVocabularyTableColumns } from 'src/util/columns'
import useQuery from 'src/hooks/useQuery'

const EntertainmentVocabularyList = () => {
  const dispatch = useDispatch()
  const query = useQuery()

  const { entertainmentVocabularies } = useSelector(store => store.mainReducer)

  const [recordToEdit, setRecordToEdit] = useState()
  const [recordToDelete, setRecordToDelete] = useState()
  const [mediaUrl, setMediaUrl] = useState()

  // useEffect(() => {
  //   dispatch(GetEntertainmentVocabularies())
  // }, [])

  const onDeleteRow = () => {
    if (recordToDelete) {
      dispatch(DeleteVocabularyById(recordToDelete))
      setRecordToDelete()
    }
  }

  return (
    <>
      <Helmet>
        <title>Entertainment Vocabulary | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <AddButton
            type="Entertainment Vocabulary"
            onClick={() => setRecordToEdit({})}
          />
          <Drawer
            anchor="right"
            open={!!recordToEdit}
            onClose={() => setRecordToEdit()}
            PaperProps={{
              sx: {
                width: 550,
                top: 64,
                height: 'calc(100% - 64px)',
              },
            }}
          >
            <AddEditVocabulary
              selectedRow={recordToEdit}
              toggleDrawer={() => setRecordToEdit()}
            />
          </Drawer>
          <Box sx={{ pt: 3 }}>
            <DataTableNew
              data={entertainmentVocabularies}
              columns={GetLessonVocabularyTableColumns(
                setMediaUrl,
                setRecordToEdit,
                setRecordToDelete
              )}
              apiName="vocabularies"
              filters={query}
            />
          </Box>
          {mediaUrl && (
            <PlayerComponent
              url={mediaUrl}
              onDialogCancel={() => setMediaUrl()}
            />
          )}
          {recordToDelete && (
            <DialogComponent
              title="Delete Entertainment Vocabulary?"
              description="Deleted entertainment vocabulary can not be recovered. Still want to delete?"
              onDialogOk={onDeleteRow}
              onDialogCancel={() => setRecordToDelete(!recordToDelete)}
            />
          )}
        </Container>
      </Box>
    </>
  )
}

export default EntertainmentVocabularyList
